import React from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import {
  FormGroup,
  Label,
  Card,
  CardHeader,
  CardBody,
  Button,
  CardDeck,
  CardTitle,
  CardText,
  CardSubtitle,
  Row,
  Col,
  CardFooter,
} from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "../../services/api/api";
import { toast } from "react-toastify";
import useCartStore from "../../stores/useCartStore";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

const OrderForm = (props) => {
  const intl = useIntl();
  const { touched, errors, isSubmitting, teacherInformation } = props;

  let adress = teacherInformation.customer.adress;
  let street = teacherInformation.customer.adress.street?.split(",");
  const cartResult = useCartStore((state) => state.result);

  return (
    <div>
      <Form>
        <div>
          <CardDeck style={{ marginBottom: "1.8rem" }}>
            <Card>
              <CardBody>
                <CardTitle>
                  <FormattedMessage id="Views.Teacher.InvoiceHistory.Invoice.Customer" />{" "}
                  {teacherInformation.name}
                </CardTitle>
              </CardBody>
            </Card>
            <Card>
              <CardBody>
                <CardTitle>
                  <FormattedMessage id="School" />{" "}
                  {teacherInformation.customer.name}
                </CardTitle>
                <span>
                  <CardSubtitle>{adress.street}</CardSubtitle>
                  <CardText>{adress.zipCode + " " + adress.city}</CardText>
                </span>
              </CardBody>
            </Card>
          </CardDeck>

          <CardDeck className="mt-3" style={{ marginBottom: "1.8rem" }}>
            <Card>
              <CardHeader>
                <h5 className="pb-0 mb-0">
                  <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.InvoiceHeader" />
                </h5>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col xs="12" sm="6">
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.Street1" />
                      </Label>
                      <Field
                        className="form-control"
                        type="input"
                        name="street1"
                        value={street ? street[0] : ""}
                        readOnly
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.Street2" />
                      </Label>
                      <Field
                        className="form-control"
                        type="input"
                        name="street2"
                        value={street && street.length > 1 ? street[1] : ""}
                        readOnly
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.Location" />
                      </Label>
                      <Field
                        className="form-control"
                        type="input"
                        name="city"
                        value={adress.city}
                        readOnly
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.ZipCode" />
                      </Label>
                      <Field
                        className={`form-control ${
                          errors.zipcode && touched.zipcode && "is-invalid"
                        }`}
                        type="input"
                        name="zipcode"
                        value={adress.zipCode}
                        readOnly
                      />
                    </FormGroup>
                  </Col>
                  <Col xs="12" sm="6">
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.Country" />
                      </Label>
                      <Field
                        className="form-control"
                        type="input"
                        name="country"
                        value={adress.country}
                        readOnly
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.Contact" />
                      </Label>
                      <Field
                        className={`form-control ${
                          errors.contact && touched.contact && "is-invalid"
                        }`}
                        type="input"
                        name="contact"
                        placeholder={intl.formatMessage({ id: "ContactPerson" })}
                      />
                      {errors.contact && touched.contact && (
                        <div className="invalid-feedback">{errors.contact}</div>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.Reference" />
                      </Label>
                      <Field
                        className={`form-control ${
                          errors.reference && touched.reference && "is-invalid"
                        }`}
                        type="input"
                        name="reference"
                        placeholder={intl.formatMessage({ id: "Views.LicenseManagement.ConfirmedOrder.OrderForm.Reference" })}
                      />
                      {errors.reference && touched.reference && (
                        <div className="invalid-feedback">
                          {errors.reference}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup>
                      <Label>
                        <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.Comments" />
                      </Label>
                      <Field
                        className={`form-control ${
                          errors.comment && touched.comment && "is-invalid"
                        }`}
                        type="input"
                        name="comment"
                        placeholder={intl.formatMessage({ id: "Comment" })}
                      />
                      {errors.comment && touched.comment && (
                        <div className="invalid-feedback">{errors.comment}</div>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </CardDeck>

          <CardDeck className="mt-3" style={{ marginBottom: "1.8rem" }}>
            <Card>
              <CardHeader>
                <h5 className="pb-0 mb-0">
                  <FormattedMessage id="LicensePackageSlashCourses" />
                </h5>
              </CardHeader>
              <CardBody>
                {props.cartList()}

                <div style={{ margin: "10px" }}>
                  <Card className="m-0" style={{ borderColor: "#46a969" }}>
                    <Row>
                      <Col>
                        <div
                          className="float-end"
                          style={{ marginRight: "15px" }}
                        >
                          {" "}
                          <h5 style={{ marginTop: "8px" }}>
                            <FormattedMessage id="TotalCost" />:{" "}
                            {intl.formatNumber(props.totalPrice, {
                              maximumFractionDigits: 2,
                            })}{" "}
                            kr
                          </h5>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </div>
              </CardBody>
              <CardFooter>
                <div className="float-start" />
                <div className="float-end">
                  <Button
                    type="submit"
                    color="success"
                    block
                    disabled={
                      isSubmitting ||
                      !cartResult ||
                      !cartResult.length ||
                      cartResult.length === 0
                    }
                  >
                    {isSubmitting ? (
                      <FormattedMessage id="Views.StudentSelfRegistration.SelfRegistrationForm.ButtonPressed" />
                    ) : (
                      <FormattedMessage id="Views.ConfirmedOrder.OrderForm.Button" />
                    )}
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </CardDeck>
        </div>
      </Form>
    </div>
  );
};

const FormikForm = withFormik({
  mapPropsToValues({ contact, reference, comment }) {
    return {
      contact: contact || "",
      reference: reference || "",
      comment: comment || "",
    };
  },
  validationSchema: Yup.object().shape({
    contact: Yup.string().required(
      <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.Required.Contact" />
    ),
    reference: Yup.string().required(
      <FormattedMessage id="Views.LicenseManagement.ConfirmedOrder.OrderForm.Required.Reference" />
    ),
  }),

  handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
    setSubmitting(true);
    const order = {
      comment: values.comment,
      contact: values.contact,
      customerId: props.teacherInformation.customer.id,
      invoiceLabeling: values.reference,
      showStudentsInOrder: true,
      shopOrderItems: [],
    };

    props.cart.result.forEach((item) => {
      item.addedStudents.forEach((stud) => {
        const shopOrderItem = {
          studentId: stud.id,
          fortNoxArticleNumber: item.fortnoxNumber,
          from: item.validFrom,
        };
        order.shopOrderItems.push(shopOrderItem);
      });
    });
    axios
      .post(`/ShopNew/Post`, {
        ...order,
      })
      .then((response) => {
        if (response.status === 200) {
          toast.success(<FormattedMessage id="Forms.OrderForm" />, {
            position: "top-right",
            closeOnClick: true,
            pauseOnHover: true,
            autoClose: 2000,
            onClose: () => props.navigate("/teacher"),
          });

          resetForm();
          setSubmitting(false);

          props.cleanCartAfterPurchase();
        }
      })
      .catch((err) => {
        toast.error(
          err.response
            ? err.response.data
              ? err.response.data
              : err.response.statusText
            : "Error",
          TOAST_CONFIG
        );
        setSubmitting(false);
      });
  },
})(OrderForm);

export default FormikForm;
